(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.fulfillment = {
        name: 'schoolwork12.fulfillment',
        controllers: {
            fulfillment : 'fulfillmentCtrl'
        },
        routes: {
            fulfillment: '/manage-computer-rules'
        },
        templates : {
            configureschool: 'fulfillment/html/configureschool.html',
            openEditModal:'fulfillment/html/configureschoolEditModal.html',
            configuredSchoolDetails:'fulfillment/html/configureschoolEditModal.html',
            openCreateModal:'fulfillment/html/configureschoolCreateModal.html',
        },
        services: {
            getAllSchools: 'getSchools'        
        },
        endpoints: {
           getAllSchoolsEndpoint: schoolwork12.app.endpoint.concat('/schools/getAllSchools'),
           fulfillmentConfiguredSchools: schoolwork12.app.endpoint.concat('/fulfillment/fulfillmentConfiguredSchools'),
           fulfillmentBundleTypes:schoolwork12.app.endpoint.concat('/fulfillment/bundleTypes'),
           reCalculateConfiguredSchool:schoolwork12.app.endpoint.concat('/fulfillment/reCalculateConfiguredSchool'),
        }
	};
	
	angular.module(schoolwork12.app.fulfillment.name,['ui.grid','ui.grid.resizeColumns','ui.grid.pagination','ngAnimate','ui.bootstrap'])
    .config([
        '$animateProvider', function($animateProvider) {
            $animateProvider.classNameFilter(/^((?!(ui-grid-menu)).)*$/);
        }
    ]);
     
}(angular, schoolwork12));